if (!customElements.get('klaviyo-back-in-stock')) {
  customElements.define('klaviyo-back-in-stock', class extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
      
      // Listen for variant changes
      document.addEventListener('product:variant-change', this.handleVariantChange.bind(this));
    }

    handleVariantChange(event) {
      const variant = event.detail.variant;
      
      // Update the variant ID in the form
      const variantInput = this.form.querySelector('.js-product-variant');
      if (variantInput) {
        variantInput.value = variant.id;
      }

      // Show/hide the back-in-stock form based on variant availability
      if (variant && !variant.available) {
        this.classList.remove('hidden');
      } else {
        this.classList.add('hidden');
      }
    }

    handleSubmit(event) {
      event.preventDefault();
      
      const email = this.form.querySelector('input[name="email"]');
      const variantId = this.form.querySelector('.js-product-variant').value;
      const companyId = this.dataset.companyId;

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2024-07-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: `${email.value}`
                  }
                }
              },
              channels: ["EMAIL"]
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        })
      };

      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`, options)
        .then(response => response)
        .then(response => {
          if (response.ok === true) {
            this.form.style.display = 'none';
            this.querySelector('.klaviyo-back-in-stock__success').classList.remove('hidden');
          } else {
            console.log('BIS failed');
          }
        })
        .catch(err => console.error(err));
    }
  });
}
